
import { Button, ListGroupItem, Row } from "react-bootstrap"
import { Card, ListGroup,Accordion } from "react-bootstrap"
import DataTable from "react-data-table-component";
import toTimeOnly from "../../utilities/toTimeOnly";
import toTimeOnly2 from "../../utilities/toTimeOnly2";
import toDateOnly from "../../utilities/toDateOnly";
import JobsheetDetailMedication from "./JobsheetDetailMedication";
import { Await, Link } from "react-router-dom";
import Icon from "../Icon/Icon";
import { useEffect , useRef, useState, useContext} from "react";
import Spinner from 'react-bootstrap/Spinner';
import { Navigate } from "react-router-dom";
import JobsheetCarerCheckInOut from "./JobsheetCarerCheckInOut";
import GoogleMap1 from "../Map/GoogleMap";
import { Alert } from "react-bootstrap";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";
// ... [existing imports]
import { Col } from "react-bootstrap";


const JobsheetDetail = ({ taskid }) => {
  const { SiteConfig } = useContext(AppContext);
  const api = useApiClient();

  const dataFetchedRef = useRef(false);
  const [data, setdata] = useState(null);
  const [error, setError] = useState(null);
  const [riskData, setRiskData] = useState([]);
  const [riskLoading, setRiskLoading] = useState(false);
  const [riskLoaded, setRiskLoaded] = useState(false);

  const baseURL = "HMCareTask/Task/" + taskid;

  const getTaskDeatilData = async (baseURL1, setdata1, setError1) => {
    try {
      const response = await api.get(baseURL1);
      setdata1(response.data);
    } catch (error) {
      setError1(error);
    }
  };

  const fetchRiskData = async () => {
    if (!data || !data.customerId) return;
    setRiskLoading(true);
    try {
      const res = await api.get(`HMCareCustomerRiskAssessment?CustomerID=${data.customerId}`);
      setRiskData(res.data);
      setRiskLoaded(true);
    } catch (err) {
      console.error("Error fetching risk assessments:", err);
    }
    setRiskLoading(false);
  };

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getTaskDeatilData(baseURL, setdata, setError);    
  }, []);

  if (error) {
    if (error.message.indexOf("status code 401")) {
      return <Navigate to="/auths/auth-login" />;
    } else {
      return `Error: ${error.message}`;
    }
  }

  if (!data) return <Spinner animation="border" variant="primary" />;

  return (
    <>
      <Row>
        <div className="col-md-6">
          <Card>
            <ListGroup variant="flush">
              <ListGroupItem>
                <h5>Job #{data.taskId} ({data.status})</h5>
              </ListGroupItem>
              <ListGroupItem action className="py-3">
                <div className="d-flex w-100 justify-content-between">
                  <div className="d-flex w-100">
                    <h5 className="mb-1">Date: {toDateOnly(data.taskDate)}</h5>
                  </div>
                  <div className="d-flex w-100">
                    <h5 className="mb-1">
                      Time: {`${toTimeOnly2(data.startTime)} - ${toTimeOnly2(data.endTime)}`}
                      <br />
                      (&nbsp;&nbsp;{data.noOfHours} Hour(s)&nbsp;&nbsp;)
                    </h5>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <h5>
                  <Icon size="sm" variant="info" name="user-fill" />
                  Client Details
                </h5>
              </ListGroupItem>
              <ListGroupItem action className="py-3">
                <p className="mb-1">
                  {data.clientName}
                  {SiteConfig.CURRENT_USER_ROLE === "admin" && (
                    <Link to={`/client/${data.customerId}`}>
                      <Icon name="external" />
                    </Link>
                  )}
                </p>
                <p>
                  {data.serviceAddress}
                  <br />
                  <b>T: </b>
                  {data.customer_phone}
                  <br />
                  <b>E: </b>
                  {data.customer_email}
                </p>
                <p><b>Service: </b>{data.serviceName}</p>
                <p>
                  <b>Assigned To: </b>
                  {data.assignedAgents && data.assignedAgents.map(agent => (                    
                    <span key={agent.agentId} style={{ marginRight: "15px" }}>
                      <Icon name="user-check-fill" /> {agent.name}
                    </span>
                  ))}
                  {!data.assignedAgents && <span>Not Assigned</span>}
                </p>
              </ListGroupItem>

              {/* Carer Check In/Out Accordion */}
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="0" flush>
                  <Accordion.Header>
                    <Icon size="md" variant="info" name="calendar-check-fill" />
                    <h5>Carer Check In / Check Out</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {data.assignedAgents.length === 0 && <>No Assigned Carers</>}
                    {data.assignedAgents.map(agent => (
                      <div key={agent.agentId}>
                        <span className="col-md-3">{agent.name}</span>
                        {agent.agentId == SiteConfig.CURRENT_USER_ID && (
                          <JobsheetCarerCheckInOut agent={agent} taskId={data.taskId} clientName={data.clientName} taskstarttime={Date.startTime} taskendtime={data.endTime} />
                        )}
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* Medication Accordion */}
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="1" flush>
                  <Accordion.Header>
                    <Icon size="md" variant="info" name="plus-medi" />
                    <h5>
                      Medications{" "}
                      {data.emarMedicationHeaders && `(${data.emarMedicationHeaders.length} Meds)`}
                    </h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    <JobsheetDetailMedication
                      customerid={data.customerId}
                      taskId={data.taskId}
                      taskDate={data.taskDate}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              
            </ListGroup>
          </Card>
        </div>

        {/* Right side content (Admin Notes, Map, etc.) */}
        <div className="col-md-6">

          {/* Risk Assessment Accordion */}
          <Accordion defaultActiveKey="">
            <Accordion.Item eventKey="2" flush>
              <Accordion.Header onClick={() => !riskLoaded && fetchRiskData()}>
                <Icon size="md" variant="info" name="bell" />
                <h5 className="mb-0 ms-2">
                  Risk Assessments
                  {!riskLoading && riskData.length > 0 && (
                    <span className="badge bg-danger ms-2">
                      {riskData.length} at risk
                    </span>
                  )}
                </h5>
              </Accordion.Header>
              <Accordion.Body>
                {riskLoading && <Spinner animation="border" variant="info" />}
                {!riskLoading && riskData.length === 0 && (
                  <Alert variant="secondary">No risk assessments found.</Alert>
                )}
                {!riskLoading &&
                  riskData.map((assessment, index) => (
                    <Card key={index} className="mb-2">
                      <Card.Body>
                        <Row>
                          <Col md={12}>
                            <p className="mb-1"><strong>Risk Area:</strong> {assessment.riskArea}</p>
                            <p className="mb-1"><strong>Description:</strong> {assessment.description || "N/A"}</p>
                            <p className="mb-1"><strong>Affects:</strong> {assessment.riskAffectsTo || "N/A"}</p>
                            <p className="mb-2"><strong>Plan:</strong> {assessment.planToManageRisk || "N/A"}</p>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col md={4}>
                            <p className="mb-1"><strong>Likelihood:</strong> {assessment.likelyhoodRank || "-"}</p>
                          </Col>
                          <Col md={4}>
                            <p className="mb-1"><strong>Severity:</strong> {assessment.severityRank || "-"}</p>
                          </Col>
                          <Col md={4}>
                            <p className="mb-1"><strong>Risk Score:</strong> <span className="text-danger">{assessment.riskScore || "-"}</span></p>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>


          {/* Admin Notes Accordion */}
         <Card>
          <ListGroup variant="flush">
            <Accordion defaultActiveKey="">
              <Accordion.Item eventKey="0" flush>
                <Accordion.Header>
                  <Icon size="lg" name="notes-alt" />
                  <h5>Admin Notes</h5>
                </Accordion.Header>
                <Accordion.Body>
                  {data.adminNotes && data.adminNotes.trim() !== "" ? (
                    <Alert variant="warning">{data.adminNotes}</Alert>
                  ) : (
                    <Alert variant="secondary">No admin notes available.</Alert>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </ListGroup>
        </Card>


          {/* Map Accordion */}
         <Card>
          <ListGroup variant="flush">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0" flush>
                <Accordion.Header>
                  <Icon size="lg" name="map-pin" />
                  <h5>Location Map</h5>
                </Accordion.Header>
                <Accordion.Body>
                  <GoogleMap1 postcode={data.serviceAddress} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </ListGroup>
        </Card>
        </div>
      </Row>
    </>
  );
};

export default JobsheetDetail;



// import { Button, ListGroupItem, Row } from "react-bootstrap"
// import { Card, ListGroup,Accordion } from "react-bootstrap"
// import DataTable from "react-data-table-component";
// import toTimeOnly from "../../utilities/toTimeOnly";
// import toTimeOnly2 from "../../utilities/toTimeOnly2";
// import toDateOnly from "../../utilities/toDateOnly";
// import JobsheetDetailMedication from "./JobsheetDetailMedication";
// import { Await, Link } from "react-router-dom";
// import Icon from "../Icon/Icon";
// import { useEffect , useRef, useState, useContext} from "react";
// import Spinner from 'react-bootstrap/Spinner';
// import { Navigate } from "react-router-dom";
// import JobsheetCarerCheckInOut from "./JobsheetCarerCheckInOut";
// import GoogleMap1 from "../Map/GoogleMap";
// import { Alert } from "react-bootstrap";
// import { useApiClient } from "../../ApiService/useApiClient";
// import { AppContext } from "../../context/AppContext";


// export const tableColumns = [  
//   {
//       name: "Notes",
//       selector: (row) => (
//         <>
//         <span className="p-5">
//         <h6>{row.notes}</h6>     
//         <p><em>Added on {toDateOnly(row.dateEnetered)} at {toTimeOnly(row.dateEnetered)}, by : {row.addedBy}</em> </p>      
//         </span> 
//         </>
//       ), 
//       sortable: true,
      
//     },  
// ];


// const JobsheetDetail = ({taskid}) => {

//   const {SiteConfig} = useContext(AppContext);
//   const api = useApiClient();

//   const dataFetchedRef = useRef(false);
//   const[data, setdata] = useState(null);  
//   const[error, setError] = useState(null); 
  
//   const baseURL = "HMCareTask/Task/"+taskid;
  
//   const getTaskDeatilData = async (baseURL1,setdata1, setError1) => {
//     try{
//     const response = await api.get(baseURL1);
//     setdata1(response.data);
//     console.log(data);
//     } catch(error) {
//       setError1(error);      
//     }
//   };

  
//   useEffect(()=>{    

//     if (dataFetchedRef.current) return;
//         dataFetchedRef.current = true;

//     getTaskDeatilData(baseURL,setdata, setError);
//    // ApiGetData(baseURL,setdata, setError);
    
//   },[]);

  
//   if (error) 
//         {      
//           if(error.message.indexOf("status code 401")){
//             return <Navigate to="/auths/auth-login" />
//            //return `Error: ${error.message} ${baseURL}`;
//           } else
//           return "Error: ${error.message}";
//         }

//     if(!data) return (
//         <Spinner animation="border" variant="primary" />
//         );
   

//   return (
//     <>

//     <Row>
//       <div className="col-md-6">
//       <Card>
//           <ListGroup variant="flush">

//           <ListGroupItem><h5>Job #{data.taskId} ({data.status})</h5></ListGroupItem>
//           <ListGroup.Item action className="py-3">
//               <div className="d-flex w-100 justify-content-between">
//                   <div className="d-flex w-100">
//                     <h5 className="mb-1">Date :  {toDateOnly(data.taskDate)}</h5>
//                   </div>
//                   <div className="d-flex w-100">
//                     <h5 className="mb-1">Time : {`${toTimeOnly2(data.startTime)} - ${toTimeOnly2(data.endTime)}`} <br></br> (&nbsp;&nbsp;{data.noOfHours} Hour(s)&nbsp;&nbsp;)</h5>
//                   </div>            
//               </div>                
//           </ListGroup.Item>
//           <ListGroupItem>
//           <h5><Icon size={"sm"} variant="info" name="user-fill"></Icon> Client Details</h5>            
//           </ListGroupItem>
//           <ListGroup.Item action className="py-3">           
//               <p className="mb-1">{data.clientName}{ SiteConfig.CURRENT_USER_ROLE == "admin" && <Link to={`/client/${data.customerId}`}><Icon name="external"></Icon></Link>}</p>              
//               <p>
//                 {data.serviceAddress}<br></br>
//                 <b>T: </b>{data.customer_phone} <br></br>
//                 <b>E: </b>{data.customer_email}
//               </p>
//               <p><b>Service: </b>{data.serviceName}</p>              
//               <p><b>Assgined To : </b>
//               {data.assignedAgents && data.assignedAgents.map((agent)=>
//                <>               
//                <span style={{marginRight:"15px"}}><Icon name="user-check-fill"></Icon> {agent.name}</span>               
//                </>
//               )}
//               {!data.assignedAgents && <span>Not Assigned</span>}
//               </p>              
//           </ListGroup.Item>
    
//           <Accordion defaultActiveKey="0">
//             <Accordion.Item eventKey="0" flush>
//               <Accordion.Header>
//                 <Icon size={"md"} variant="info" name="calendar-check-fill"></Icon><h5>Carer Check In / Check Out</h5>
//               </Accordion.Header>
//               <Accordion.Body>
                
//                  {
//                  data.assignedAgents.length == 0 &&
//                   <>No Assigned Carers</>
//                  }

//               {data.assignedAgents.length > 0 && data.assignedAgents.map((agent)=>
//                 <>
//                   <div key={agent.agentId}>
//                     <span className="col-md-3">{agent.name}</span>
//                     {
//                       (agent.agentId == SiteConfig.CURRENT_USER_ID) && 
//                         <JobsheetCarerCheckInOut agent={agent} taskId={data.taskId} clientName={data.clientName} />             
//                     }
//                   </div>
//                 </>
//               )}

//               </Accordion.Body>
//             </Accordion.Item>  
//           </Accordion>  

//           <Accordion defaultActiveKey="">
//             <Accordion.Item eventKey="0" flush>
//               <Accordion.Header>
//                 <Icon size={"md"} variant="info" name="plus-medi"></Icon><h5>Medications {data.emarMedicationHeaders && <> ( {data.emarMedicationHeaders.length} Meds )</> }</h5>
//               </Accordion.Header>
//               <Accordion.Body>   
//                 <JobsheetDetailMedication customerid={data.customerId} taskId={data.taskId} taskDate={data.taskDate}/>
//               </Accordion.Body>
//             </Accordion.Item>  
//           </Accordion>     

//           </ListGroup>
//       </Card>
//       </div>      
//       <div className="col-md-6">
//       <Card>
//           {/* <Card.Header>Service Details</Card.Header> */}
//           <ListGroup variant="flush">
//           <Accordion defaultActiveKey="0">
//             <Accordion.Item eventKey={(data.adminNotes!="" ?"0" : "")} flush>
//               <Accordion.Header>
//               <Icon size={"lg"} name="notes-alt"></Icon><h5>Admin Notes</h5>
//               </Accordion.Header>
//               <Accordion.Body> 
//                 <Alert variant="warning">
//                   {data.adminNotes}
//                 </Alert>
//               </Accordion.Body>
//             </Accordion.Item>  
//           </Accordion> 
//           </ListGroup>    
//       </Card>        
//       <Card>
//           {/* <Card.Header>Service Details</Card.Header> */}
//           <ListGroup variant="flush">
//           <Accordion defaultActiveKey="0">
//             <Accordion.Item eventKey="0" flush>
//               <Accordion.Header>
//               <Icon size={"lg"} name="map-pin"></Icon><h5>Location Map</h5>
//               </Accordion.Header>
//               <Accordion.Body>   
//                         <GoogleMap1 postcode={data.serviceAddress} />
//               </Accordion.Body>
//             </Accordion.Item>  
//           </Accordion> 
//           </ListGroup>    
//       </Card>        
      
      
//       {false && 
//       <Card>         
//           <ListGroup variant="flush">
//           <Accordion defaultActiveKey="0">
//             <Accordion.Item eventKey="" flush>
//               <Accordion.Header>
//               <Icon size={"lg"} name="notes-alt"></Icon><h5>Job Notes</h5>
//               </Accordion.Header>
//               <Accordion.Body>                           
//                         <DataTable 
//                           tableClassName="data-table-head-light table-responsive" 
//                           data={data.tasknotes} 
//                           columns={tableColumns} 
//                           striped={true} 
//                           highlightOnHover={true} 
//                           filterFieldName={""} 
//                           paginationPerPage={5} 
//                           pagination={true}                                 
//                           noTableHead = {true}                          
//                         /> 
//               </Accordion.Body>
//             </Accordion.Item>  
//           </Accordion> 
//           </ListGroup>    
//       </Card>       
//     } 
     
//       </div>
//     </Row>   
//     </>
    
//   )
// }

// export default JobsheetDetail